interface ExerciseNumberBadgeProps {
    number: number;
}

/**
 * The exercise number as a plain rounded square, used where an exercise is finished and there is no
 * progress to show — the evaluation and result views. The online test uses CircularProgress instead,
 * whose ring tracks how much of the exercise is answered.
 */
const ExerciseNumberBadge = (props: ExerciseNumberBadgeProps) => {
    return (
        <div className="shrink-0 flex items-center justify-center min-w-xl min-h-xl px-xs rounded-xsmall-container border border-p6-grey-lightest bg-background-light">
            <span className="text-l font-semibold text-p6-grey-dark">{props.number}</span>
        </div>
    );
};

export default ExerciseNumberBadge;
